import { authHeaders, requestJson } from '../api/http';

const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';

export interface CreatedVoice {
  voice_id: string;
  user_id: string;
  message: string;
}
export async function createVoice(voiceName: string): Promise<CreatedVoice> {
  const form = new FormData();
  form.append('voice_name', voiceName.trim());
  return requestJson<CreatedVoice>(`${API_BASE_URL}/voice/create-voice`, {
    method: 'POST',
    headers: authHeaders(),
    body: form,
  });
}
